// In case the funding is EMPLOYEE, the trial length is extracted from the monthly fee select
// as every option has as value the price and the trial length separated by a dash ${price}-${trialLength}
export const extractTrialLengthFromMonthlyFeeSelect = (
  value: string
): string => {
  return value.split('-')[1];
};

// In case the funding is EMPLOYEE, the price is extracted from the monthly fee select
// as every option has as value the price and the trial length separated by a dash ${price}-${trialLength}
export const extractPriceFromMonthlyFeeSelect = (value: string): string => {
  return value.split('-')[0];
};
